import { getCustomCursor } from '../ui/helper';

export const ANNOTATION_TYPE = {
  HLINE: 'HorizontalCaliper',
  VLINE: 'VerticalCaliper',
  TEXT: 'TextAnnotation',
  BCC: 'BeatComplexCalipers',
  EVENT_POSITION: 'EventPosition',
  SAMPLE_MARK: 'SampleMark',
  RECT_SELECT: 'RectangleSelection',
  PATTERN: 'Pattern',
  BEAT_MARKER: 'BeatMarkers',
  AFIB_EVENT: 'AFibEvent',
  NOISE_EVENT: 'NoiseEvent',
  EVENT_INDICATOR: 'EventIndicator',
};

export const DEFAULT_FONT = 'Inconsolata, Arial, Helvetica, sans-serif';

export const BCC_LABELS = ['P', 'Q', 'R', 'S', 'T', 'R2'];

export const MOUSE_CURSOR = {
  DEFAULT: 'default',
  CROSSHAIR: 'crosshair',
  ZOOM_IN: 'zoom-in',
  POINTER: 'pointer',
  ARROW: 'arrow',
  MOVE: 'move',
  DELETE_BEAT_CURSOR: getCustomCursor(),
};

export const EVENT_STATUSES = {
  NEW: 'New',
  EDITED: 'Edited',
  NEEDS_VERIFICATION: 'Needs Verification',
  APPROVED: 'Approved',
};

export const WIDGET_TYPE = {
  DRAG: 0,
  HORIZONTAL_CALIPER: 1,
  VERTICAL_CALIPER: 2,
  TEXT_ANNOTATION: 3,
  BEAT_COMPLEX_CALIPERS: 4,
  ZOOM: 5,
  SECTION: 6,
  BEAT_REMOVAL: 7,
  EVENT_MARKER: 8,
  EVENT_POSITION: 9,
};

export const WIDGET_UNITS = {
  MILLISECONDS: 'ms',
  MILLIVOLTS: 'mV',
  SECONDS: 's',
  MINUTES: 'min',
};

export const TOOLBAR_TYPE = {
  SPEED: 'SPEED',
  GAIN: 'GAIN',
  HIGH_PASS: 'HP',
  LOW_PASS: 'LP',
};
